import React, { useEffect, useContext } from 'react';
import { auth } from '../../base-ui/utils';
import { useNavigate } from 'react-router-dom';
import { ConfigContext } from '../../base-ui/Config/ConfigContext';

const Logout: React.FC = () => {
	const navigate = useNavigate();
	const { config }: any = useContext(ConfigContext);

	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search);
		const reason = urlParams.get('reason');
		

		auth.logout();

		if (reason === 'session-expired' && config?.logoutUrl) {
			window.location.href = config.logoutUrl;
		} else {
			navigate('/login');
		}
	}, [config]);

	return <></>;
};

export default Logout;
